import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DemoDashboard } from '../components/demo/DemoDashboard'
import { CompanyUserDashboard } from '../components/company/CompanyUserDashboard'
import { CompanyAdminDashboard } from '../components/company/CompanyAdminDashboard'
import { SuperAdminDashboard } from '../components/admin/SuperAdminDashboard'

interface User {
  id: string
  email: string
  name: string
  role: string
  company_name?: string
}

export function Dashboard() {
  const navigate = useNavigate()
  const [user, setUser] = useState<User | null>(null)

  useEffect(() => {
    // Check if user is logged in
    const userStr = localStorage.getItem('user')
    if (!userStr) {
      navigate('/login')
      return
    }
    try {
      const userData = JSON.parse(userStr)
      setUser(userData)
    } catch (error) {
      console.error('Failed to parse user data:', error)
      navigate('/login')
    }
  }, [navigate])

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    )
  }

  // Show demo dashboard for demo users
  if (user.role === 'demo') {
    return <DemoDashboard userName={user.name} />
  }

  // Show company user dashboard for company users
  if (user.role === 'company_user') {
    return <CompanyUserDashboard userName={user.name} companyName={user.company_name} />
  }

  // Show company admin dashboard for company admins
  if (user.role === 'company_admin') {
    return <CompanyAdminDashboard userName={user.name} companyName={user.company_name} />
  }

  // Show super admin dashboard for super admins
  if (user.role === 'super_admin') {
    return <SuperAdminDashboard userName={user.name} />
  }

  // Fallback for unknown roles
  return (
    <div className="bg-card p-8 rounded-lg border border-border">
      <h1 className="text-2xl font-semibold text-foreground mb-4">Unknown Role</h1>
      <p className="text-muted-foreground">
        Your role ({user.role}) is not recognized. Please contact support.
      </p>
    </div>
  )
}
